import { schema as schemas } from 'normalizr'

import { type CallApi } from '@signavio/kraken'

import { TestRunPayloadType } from '../../../../../types/activities'

export const collection = 'testRuns'

export const schema = new schemas.Entity(
  collection,
  {},
  {
    idAttribute: (testResult) => JSON.stringify(testResult),
  }
)

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { script, testValues }: TestRunPayloadType) =>
    callApi(`${apiBase}/javascript/test`, schema, {
      method: 'POST',
      body: {
        script,
        testValues,
      },
    })
